/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
 * Keyscaper: personalized products must not reach the cart without their text.
 * (2026-10-02, order #14811; broken_cactus services/personalization_resolution.py)
 *
 * The theme's <buy-button> adds to cart BY SCRIPT: its click handler calls
 * preventDefault() and POSTs the form to /cart/add.js, so the browser never makes a
 * real form submission and never checks the personalization input's `required`.
 * Reproduced live: an empty field, one click, and the cart held
 * "Personalized Text": "". This listener runs on the document in the CAPTURE phase,
 * i.e. before <buy-button>'s own handler, and refuses the click while the field in
 * the same form is empty or only spaces. It is delegated, so it also covers
 * quick-view drawers, whose inline <script> tags never execute.
 *
 * It also uppercases and filters the field (A-Z, 0-9, space) for EVERY rendered
 * copy: the per-snippet binding finds inputs by id, and the PDP renders the field
 * twice under one id, so only the first copy was ever bound.
 */
(function () {
  if (window.__ksPersonalizationGuard) return;
  window.__ksPersonalizationGuard = true;

  var FIELD = 'input[name="properties[Personalized Text]"]';
  var MESSAGE = 'Please enter your personalization text (up to 18 characters).';

  function hasText(input) {
    var ok = !!(input.value && input.value.trim());
    input.setCustomValidity(ok ? '' : MESSAGE);
    return ok;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('buy-button, button[type="submit"], input[type="submit"]');
    if (!button) return;
    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector(FIELD);
    if (!input || hasText(input)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    input.focus();
    input.reportValidity();
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(FIELD)) return;
    var caret = input.selectionStart;
    var original = input.value;
    var clean = '';
    var newCaret = caret;
    for (var i = 0; i < original.length; i++) {
      var ch = original[i].toUpperCase();
      if (/[A-Z0-9 ]/.test(ch)) {
        clean += ch;
      } else if (i < caret) {
        newCaret--;
      }
    }
    if (clean !== original) {
      input.value = clean;
      try { input.setSelectionRange(newCaret, newCaret); } catch (e) {}
    }
    if (input.validationMessage) hasText(input);
  }, true);
})();

